import { gql } from '@apollo/client';

/**
 * 发送账单（Step2 确认后）
 */
export const SEND_BILL = gql`
  mutation SendBill($sendRequest: BillSendRequestInput!) {
    sendBill(sendRequest: $sendRequest) {
      success
      errorMessage
      successCount
      failureCount
      details {
        email
        success
        message
      }
    }
  }
`;

